package io.daio.pancake.components.item

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.unit.dp
import io.daio.pancake.foundations.Theme
import io.daio.pancake.foundations.text.BodyText
import io.daio.pancake.foundations.text.BodyTextLarge
import io.daio.pancake.layout.Stack

@Composable
fun NavigationItem(
    title: String,
    modifier: Modifier = Modifier,
    icon: Painter? = null,
    subtitle: String? = null,
    onAction: (() -> Unit)? = null
) {
    CustomItem(
        modifier = modifier,
        onAction = onAction,
        leadingItem = {
            icon?.let {
                Image(it, "", Modifier.size(32.dp))
            }
        },
        mainContent = {
            Stack(modifier = Modifier.weight(1f)) {
                BodyTextLarge(title)
                subtitle?.let {
                    BodyText(it)
                }
            }
        },
        trailingItem = {
            Box(Modifier.padding(Theme.dimens.size_m)) {
                BodyTextLarge(">") // TODO should be an icon.
            }
        }
    )
}